export default "__VITE_ASSET__Nv63sD$q__"